
import { useStaticQuery, graphql } from "gatsby"

const GetTechnologiesImgs = () => {
  const data = useStaticQuery(graphql`
  query AssetsTechnologies {
    allFile(filter: {extension: {regex: "/(jpg)|(svg)|(png)/"}, relativeDirectory: {eq: "technologies"}}) {
      edges {
        node {
          id
          name
          publicURL 
          
        }
      }
    }
  }
  `)


  return data.allFile.edges
}

export default GetTechnologiesImgs
